module.exports = require("plugin-assets/shared/widget/components/styled");